<template>
  <div class="accout-login">
    <a-form
      :form="form"
      @submit.prevent="loginHandle"
    >
      <a-form-item
        label=""
      >
        <a-input
          v-decorator="decorators.mobile"
          :placeholder="mobileTit"
          :maxlength="11"
        />
      </a-form-item>
      <!-- <captcha-input /> -->
      <a-form-item
        label=""
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="validTit"
          class="password-input"
        />
        <get-code
          class="find-pwd-link"
          type="9"
          :is-disabled="isDisabled"
          :mobile="form.getFieldValue('mobile')"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["196"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
// import { fetchApi } from '@/common'
import { mapState, mapActions } from 'vuex'
import GetCode from '@/components/pc/GetCode.vue'
import loginMin from '@/store/account/loginMin'
// import CaptchaInput from '@/components/pc/CaptchaInput.vue'
export default {
  'name': 'TelLogin',
  components: {
    GetCode
  },
  mixins: [loginMin],
  data () {
    return {
      isDisabled: false,
      getCodeUrl2: '',
      formLayout: 'horizontal'
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators']),
    mobileTit () {
      return this.$t('message["1112"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/login', ['login', 'toOrgProject']),
    loginHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { logintype: 2 })
          const chain = await this.login()
          chain.params(obj)
            .onSuccess(async (raw) => {
              const chain2 = await this.toOrgProject()
              chain2.onSuccess(res => {
                this.getOrgPro(res)
              })
            })
            .setForm(this.form)
            .fetch()
        }
      })
    }
  }
}
</script>

<style lang="scss" >

.accout-login {
  .login-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    ::v-deep .ant-form-item-children {
      display: inline-block
    }
    .find-pwd-link {
      position: absolute;
      right: 12px;
      button {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
        margin: 0 12px 0 0;
      }
    }
  }
}
</style>
